export const LIFECYCLE_STATUS_LABEL = "Lifecycle Status";
export const PRODUCTION_STATUS_LABEL = "Production Lifecycle Status";
export const SALES_STATUS_LABEL = "Sales Lifecycle Status";
